"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ROW_HEIGHT = 38;
const styles = ({ palette, components }) => ({
    root: {
        border: `1px solid ${palette.divider}`,
    },
    table: {
        paddingLeft: 24,
        paddingRight: 24,
        display: 'flex',
        flexFlow: 'column',
        height: 'inherit',
    },
    tableWrapper: {
        overflowX: 'auto',
        height: '100%',
    },
    rowContainer: {
        display: 'flex',
        background: 'unset',
        cursor: 'pointer',
        height: ROW_HEIGHT,
        borderBottom: 'solid',
        borderBottomColor: palette.grey[100],
        borderBottomWidth: 1,
        '&:focus': {
            outline: 'none',
        },
        overflow: 'hidden',
    },
    rowItem: {
        margin: 'auto',
        flex: 1,
        fontSize: components.register.fontSize.small,
    },
    checkRow: {
        minWidth: 45,
        flex: 0,
    },
    footer: {
        height: 30,
        flex: '0 1 30px',
    },
    rowsSection: {
        flex: '1 1 auto',
        paddingTop: 5,
        paddingBottom: 5,
    },
    header: {
        flex: '0 1 auto',
        minHeight: 30,
    },
    checkButton: {
        height: ROW_HEIGHT,
    },
    rowChild: {
        height: 25,
        margin: 'auto',
        padding: 0,
        marginRight: 12,
    },
});
exports.default = styles;
